import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=542396d0&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=542396d0&prod&lang=css"
import style1 from "./layout.vue?vue&type=style&index=1&id=542396d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542396d0",
  null
  
)

export default component.exports